import React, { useEffect, useRef } from 'react';

import { Spinner } from '@infoods/lifebase-ui';

import classes from './NgzResources.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useModalToggle } from '../../../shared/hooks/useModalToggle';

const NgzResources = () => {
  const [isShowSpinner, toggleIsShowSpinner] = useModalToggle(true);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (iframeRef.current) {
      iframeRef.current.onload = toggleIsShowSpinner;
    }
  }, []);

  return (
    <div>
      <iframe
        ref={iframeRef}
        src="https://belitenutrition.com/coach-resources/"
        title="Resources"
        className={classes.iframeContent}
      />
      <Spinner isLoading={isShowSpinner} isGlobal />
    </div>
  );
};

angularizeWithProviders(NgzResources, 'ngzResources', {});

export default NgzResources;
